import React from "react";
import { useHistory } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";

/**
 * Objective Component
 * Displays activity selection options: Plotting, Computing, and Heading
 */
const Objective = (props) => {
  const history = useHistory();
  return (
    <div id="page">
      <Header onBack={() => history.push("/choosetype")} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="row mb-0">
          <div className="col-md-12 text-center">
            <span className="m-3">Choose the type of activity:</span>
          </div>
        </div>
        <div className="row text-center mb-3 justify-content-center">
          <a
            onClick={() => {
              props.setstep("orientation");
            }}
            href="javascript:;"
            className="col-6"
          >
            <div className="card card-style mb-3">
              <i className="fas fa-chart-area color-magenta-dark fa-3x mt-5"></i>
              <h3 className="pt-4">Plotting Discontinuity Trace</h3>
              <p className="font-11 opacity-50 mt-n2">
                Plotting Discontinuity Trace on the Tunnel Log
              </p>
              <p className="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
            </div>
          </a>
          {/* The Computing Discontinuity Orientation activity now lives in the
              FaceLog3D web tool; its components stay routable here. */}
          {/* <a
            onClick={() => {
              props.setstep("heading");
            }}
            href="javascript:;"
            className="col-4 ps-0"
          >
            <div className="card card-style ms-2 mb-3">
              <i className="fas fa-heading color-highlight fa-3x mt-5"></i>
              <h3 className="pt-4">Projection from heading</h3>
              <p className="font-11 opacity-50 mt-n2">
                Log Plot Projection from heading
              </p>
              <p className="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
            </div>
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default Objective;






